module.exports = __webpack_public_path__ + "static/media/292x0w (5).bed0b265.webp";